interface InputFieldProps {
  label: string;
  placeholder: string;
  type: string;
  value: string;
  onChange: (value: string) => void;
}

export function InputField({
  label,
  placeholder,
  type,
  value,
  onChange,
}: InputFieldProps) {
  return (
    <div className="flex flex-col gap-2 w-full">
      <label className="text-sm font-medium text-stone-700 text-left">
        {label}
      </label>
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="box-border px-4 py-3 w-full text-sm bg-gray-200 rounded-lg border-0 focus:outline-none focus:ring-2 focus:ring-stone-700 transition-all"
      />
    </div>
  );
}
